import { createAsyncAction, createAction } from 'typesafe-actions';

export const getNegotiationDetails = createAsyncAction(
  '@GET_NEGOTIATIONDETAILS/REQUEST',
  '@GET_NEGOTIATIONDETAILS/SUCCESS',
  '@GET_NEGOTIATIONDETAILS/FAILURE'
)<GQL.IGetDealOptionsOnQueryArguments, Array<GQL.IOption>, string>();

export const setNegotiationState = createAsyncAction(
  '@SET_NEGOTIATIONSTATE/REQUEST',
  '@SET_NEGOTIATIONSTATE/SUCCESS',
  '@SET_NEGOTIATIONSTATE/FAILURE'
)<undefined, GQL.IInsertNegotiationModel, string>();

export const setForceRecalculation = createAsyncAction(
  '@SET_FORCERECALCULATION/REQUEST',
  '@SET_FORCERECALCULATION/SUCCESS',
  '@SET_FORCERECALCULATION/FAILURE'
)<boolean, boolean, string>();

export const confirmNegotiation = createAsyncAction(
  '@SET_NEGOTIATIONDETAILS/REQUEST',
  '@SET_NEGOTIATIONDETAILS/SUCCESS',
  '@SET_NEGOTIATIONDETAILS/FAILURE'
)<INegotiationDetail, GQL.IConfirmationInfo, null>();

export const getDebtDetails = createAsyncAction(
  '@SET_DEBTDETAILS/REQUEST',
  '@SET_DEBTDETAILS/SUCCESS',
  '@SET_DEBTDETAILS/FAILURE'
)<IDebtDetail, GQL.IDebtDetailInfo, null>();

export const setDeal = createAsyncAction(
  '@SET_DEAL/REQUEST',
  '@SET_DEAL/SUCCESS',
  '@SET_DEAL/FAILURE'
)<GQL.ISetDealOnQueryArguments, GQL.IState, string>();

export const getDealState = createAsyncAction(
  '@GET_DEALSTATE/REQUEST',
  '@GET_DEALSTATE/SUCCESS',
  '@GET_DEALSTATE/FAILURE'
)<GQL.IGetDealStateOnQueryArguments, GQL.IState[], string>();

export const getConfirmatedInfos = createAsyncAction(
  '@GET_DEALSTATE/REQUEST',
  '@GET_DEALSTATE/SUCCESS',
  '@GET_DEALSTATE/FAILURE'
)<IConfirmatedInfos>();

//Começando retirar as sagas do projeto

export const setPhoneCode = createAction('SET_PHONE_CODE')<string | null>();
export const setEmailCode = createAction('SET_EMAIL_CODE')<string | null>();
export const setAddressCode = createAction('SET_ADDRESS_CODE')<string | null>();
export const setAuxiliar = createAction('SET_AUXILIAR')<string | null>();
export const setEnableSpecialCheck = createAction('SET_ENABLE_SPECIAL_CHECK')<
  number | null
>();
export const setAutomaticDebt = createAction('SET_AUTOMATIC_DEBT')<
  number | null
>();

export const clearDealStatus = createAction('@CLEAR_DEAL_STATUS')<undefined>();
